module.exports = __webpack_public_path__ + "img/reason1.a0fb6709.png";